import React from 'react';

import { Modal } from './';
import { LoadingSpinner } from '@edx/components/loading-spinner';

export const ProcessingModal: React.FC = () => (
  <Modal>
    <div className="inline-flex">
      <LoadingSpinner className="text-primary-500" />
      Estamos procesando tu petición...
    </div>
  </Modal>
);
